// Author Eric
// Date 2020-10-02 11:53:39

class SithMesAndonTypePosition {
constructor({
        id = null,
        andonTypeId = '',
        mstPositionId = '',
        mstPositionName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.andonTypeId = andonTypeId;
    this.mstPositionId = mstPositionId;
    this.mstPositionName = mstPositionName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesAndonTypePosition();
}

function gridFields() {
return Object.freeze([
        {
        key: 'andonTypeName',
        label: 'label.sith.andon.sithMesAndonTypePosition.grid.andonTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstPositionName',
        label: 'label.sith.andon.sithMesAndonTypePosition.grid.mstPositionName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTypePosition.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    andonTypeIdFilter : "",
    mstPositionIdFilter : "",
    mstPositionNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'andonTypeIdFilter',
        label: 'label.sith.andon.sithMesAndonTypePosition.filter.andonTypeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstPositionNameFilter',
        label: 'label.sith.andon.sithMesAndonTypePosition.filter.mstPositionName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstPositionId":"id"}'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'andonTypeId',
        label: 'label.sith.andon.sithMesAndonTypePosition.entity.andonTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstPositionName',
        label: 'label.sith.andon.sithMesAndonTypePosition.entity.mstPositionName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstPositionId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTypePosition.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesAndonTypePosition, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
